import React from 'react';
import Image, {type ImageProps} from 'next/image';
import {config} from '@modules/config';

type StrapiImageAsset = {
	url?: string;
	hash?: string;
	width?: number;
	height?: number;
};

const DEFAULT_IMAGE_QUALITY = 80;

function strapiImageLoader({
	src,
	width,
	quality,
}: {
	src: string;
	width: number;
	quality?: number;
}) {
	return `${config.get('deezerImagesUrl')}/misc/${src}/0x${width}-000000-${quality ?? DEFAULT_IMAGE_QUALITY}-0-0.webp`;
}

type StrapiOptimizedImageProps = Omit<
	ImageProps,
	'src' | 'width' | 'height'
> & {
	image?: StrapiImageAsset;
};

export const StrapiOptimizedImage: React.FC<StrapiOptimizedImageProps> = ({
	image,
	priority,
	fetchPriority,
	quality,
	sizes,
	style,
	...props
}) => {
	if (!image?.hash || !image.width || !image.height) {
		return null;
	}
	const imageProps = {
		...props,
		loader: strapiImageLoader,
		src: image.hash,
		width: image.width,
		height: image.height,
		quality,
		priority,
		sizes,
		fetchPriority: priority ? 'high' : fetchPriority,
		style: {
			maxWidth: '100%',
			height: 'auto',
			...style,
		},
	} satisfies ImageProps;

	return (
		<picture>
			<Image {...imageProps} />
		</picture>
	);
};
